var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.46,
    height: 15,
    viewBox: "0 0 15.46 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "app_language",
    transform: "translate(-328.781 -131.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(329.281 132)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-854.059-546.343a.5.5,0,0,1-.18-.034.5.5,0,0,1-.32-.466v-9.333a.5.5,0,0,1,.5-.5h7.23a.5.5,0,0,1,.5.5v7.23a.5.5,0,0,1-.5.5h-5.1l-1.757,1.939A.5.5,0,0,1-854.059-546.343Zm.5-9.333v7.537l1.036-1.143a.5.5,0,0,1,.37-.164h4.824v-6.23Z",
    transform: "translate(854.059 560.843)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-691.535-646.578a.5.5,0,0,1-.371-.164l-1.757-1.939h-5.1a.5.5,0,0,1-.5-.5v-7.23a.5.5,0,0,1,.5-.5h7.23a.5.5,0,0,1,.5.5v9.333a.5.5,0,0,1-.32.466A.5.5,0,0,1-691.535-646.578Zm-6.73-3.1h4.824a.5.5,0,0,1,.37.164l1.036,1.143v-7.537h-6.23Z",
    transform: "translate(705.995 656.412)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(1.397 5.74)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-820.836-529.261h-2.028l-.348.99h-.829l1.735-4.851h.92l1.735,4.851h-.836Zm-.223-.648-.787-2.251-.795,2.251Z",
    transform: "translate(824.042 533.122)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(8.368 1.328)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-672.414-623.963a1.386,1.386,0,0,1-.791-.227,2.3,2.3,0,0,1-.6-.606,8.094,8.094,0,0,1-.509-.84l.265-.153q.181.328.373.631a1.873,1.873,0,0,0,.443.495.981.981,0,0,0,.613.192.974.974,0,0,0,.436-.1.907.907,0,0,0,.338-.282.7.7,0,0,0,.132-.425.464.464,0,0,0-.171-.39.636.636,0,0,0-.4-.132,1.128,1.128,0,0,0-.4.08q-.209.08-.369.157l-.3-.509a2.97,2.97,0,0,1,.415-.188,1.327,1.327,0,0,1,.463-.084h.063a.851.851,0,0,0,.286-.282.64.64,0,0,0,.1-.331.421.421,0,0,0-.112-.3.469.469,0,0,0-.355-.118,1.8,1.8,0,0,0-.5.094,2.443,2.443,0,0,0-.592.275l-.307-.523a2.487,2.487,0,0,1,.617-.265,2.1,2.1,0,0,1,.533-.084,1.026,1.026,0,0,1,.544.136,1.147,1.147,0,0,1,.362.345,1.616,1.616,0,0,1,.206.429,1.363,1.363,0,0,1,.066.387.889.889,0,0,1-.035.237.71.71,0,0,1-.167.272.646.646,0,0,1,.091.1,1.435,1.435,0,0,0,.275.237.839.839,0,0,0,.463.1.954.954,0,0,0,.648-.23l.014-1.4h-.746l-.237-.453v-.07h2.147l.237.453v.07h-.815l.014,3.868h-.07l-.558-.362.007-1.4a.489.489,0,0,1-.119.028,1.187,1.187,0,0,1-.132.007,1.123,1.123,0,0,1-.387-.07,1.617,1.617,0,0,1-.331-.16l-.028.014a.891.891,0,0,1,.059.2,1.146,1.146,0,0,1,.017.192.863.863,0,0,1-.157.509,1.081,1.081,0,0,1-.422.352A1.366,1.366,0,0,1-672.414-623.963Z",
    transform: "translate(674.317 627.88)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.601362b839499ec6f2e93236bd1a56bd.svg";
export { ForwardRef as ReactComponent };